import { HttpEventType } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Course, AddCourseDefaultValues } from '../course';
import { FileService } from 'src/app/services/file.service';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { CourseService } from 'src/app/services/course.service';
import { TagsService } from 'src/app/services/tag-service.service';
import { CourseList, CourseListDefaultValues } from '../course-list';
import { map, Observable, of, startWith } from 'rxjs';
import { FormControl } from '@angular/forms';
// import * as $ from 'jquery';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast-service.service';

declare var $: any;
@Component({
    selector: 'app-course-details',
    templateUrl: './course-details.component.html',
    styleUrls: ['./course-details.component.scss'],
    standalone: false
})

export class CourseDetailsComponent implements AfterViewInit,OnInit {
  @Input() course: Course = AddCourseDefaultValues();
  @Input() isSubmitted: boolean = false;
  @Input() selectedPrograms: any[] = [];
  @Input() selectedTags: any[] = [];
  @Input() courseStatus: any[] = [];
  @Input() hasEnrolledUsers:boolean=false
  @Input() disabledPrograms:any[]=[]
  

  courseLanguage: any[] = [];
  coursePrograms: any[] = [];
  tags: any[] = [];
  selectedFile: File | null = null;
  selectedFileName: string = 'Drag and drop your file here or click to upload '
  showReplacementDiv: boolean = false;
  replacementRadioValue: string = "2";
  showReplacementFileSelector: boolean = false;
  selectedCourse: CourseList = CourseListDefaultValues();
  filteredOptions!: Observable<CourseList[]>;
  myControl = new FormControl<string | CourseList>('');
  replacementCourse: CourseList[] = [];
  courseDescription: string = '';
  courseTypes:any[]=[]
  isUploading: boolean = false;
  uploadProgress: number = 0;
  isUploadComplete: boolean = false;

 

  constructor(private fileservice: FileService,
    private _courseservice: CourseService,
    private tagservice: TagsService,
    private appprogservice: ApplicationProgramsService,
    private route: ActivatedRoute,
    private toastservice: ToastService) {
  }

  ngOnInit() {
    this.loadDoprdowns();
    this.setContent('hi');
    
 }

  ngAfterViewInit(): void {
    $('#summernoteEditor').summernote({
      placeholder: 'Write your content here...',
      tabsize: 2,
      height: 300,
      disableDragAndDrop: true,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol']],
      ],
      callbacks: {
        onChange: (contents: string) => {
          this.courseDescription = contents
        }
      }
    });
  }

  setContent(content: string) {
    $('#summernoteEditor').summernote('code', content);
  }

  loadDoprdowns() {
    this._courseservice.getCourseLanguages().subscribe({
      next: (response) => {
        this.courseLanguage = response;
      }
    });

    this.tagservice.getActiveTags().subscribe({
      next:(resp) => {
        this.tags = resp;
      }
    })

    this.appprogservice.getCoursePrograms().subscribe({
      next:(resp) => {
        this.coursePrograms=resp;
      }
    })
    
    this._courseservice.getCourseTypes().subscribe({
      next: (response) => {
        this.courseTypes = response;  
      }
    })
  }

  compareCourseType = (a: number | string, b: number | string): boolean =>
    Number(a) === Number(b);

  onSelect(event: NgxDropzoneChangeEvent) {
    this.selectedFileName=''

    const file = event.addedFiles[0]; // Get the first file selected

    if (file) {
      this.selectedFileName = file.name;
      const formData = new FormData();
      formData.append('file', file);

      this.isUploading = true;
      this.isUploadComplete = false;
      this.uploadProgress = 0;
      this.fileservice.uploadfile(formData).subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.uploadProgress = Math.min(99, Math.round((100 * event.loaded) / event.total));
          } else if (event.type === HttpEventType.Response) {
            this.course.courseThumbnailFileId = event.body.id;
            this.course.courseThumbnailName = event.body.fileName;
            this.uploadProgress = 100;
            this.isUploadComplete = true;
            setTimeout(() => {
              this.isUploading = false;
              this.isUploadComplete = false;
            }, 1500);
          }
        },
        error: () => {
          this.isUploading = false;
          this.isUploadComplete = false;
          this.uploadProgress = 0;
          this.selectedFileName = 'Drag and drop your file here or click to upload ';
          this.toastservice.showErrorMessage('File upload failed. Please try again.');
        }
      });
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  getTagNames(id: string): string {
    const tag = this.tags.find(t => t.id === id);
    return tag ? tag.tagName : '';
  }

  getProgramNames(id: number): string {
    const prog = this.coursePrograms.find(t => t.id === id);
    return prog ? prog.programName : '';
  }

  onTagSelectionChange() {
    this.course.tagId = this.selectedTags;
  }

  onProgramSelectionChange() {
    const adultMaterialsProgramId = 7;
    const hasAdultMaterials = this.selectedPrograms.includes(adultMaterialsProgramId);
    const hasOtherPrograms = this.selectedPrograms.some((id: number) => id !== adultMaterialsProgramId);

    if (hasAdultMaterials && hasOtherPrograms) {
      const lastSelected = this.selectedPrograms[this.selectedPrograms.length - 1];
      if (lastSelected === adultMaterialsProgramId) {
        this.selectedPrograms = [adultMaterialsProgramId];
      } else {
        this.selectedPrograms = this.selectedPrograms.filter((id: number) => id !== adultMaterialsProgramId);
      }
    }

    this.course.coursePrograms = this.selectedPrograms;
  }

  statusChange() {
    this.showReplacementDiv=false;
    // if(this.course.courseStatus == 3) {
    //   this.showReplacementDiv = true;
    //   this.fetchReplacementCourses();
    // } else {
    //   this.showReplacementDiv=false;
    // }
  }

  replacementRadioChange() {
    if (this.replacementRadioValue == "1") {
      this.showReplacementFileSelector = true;
      this.course.isReplaced = true;
    } else {
      this.showReplacementFileSelector = false;
      this.course.isReplaced = false;
    }
  }

  private _filter(name: string): CourseList[] {
    const filterValue = name.toLowerCase();
    return this.replacementCourse.filter(option => option.courseName.toLowerCase().includes(filterValue));
  }

  displayFn(course: CourseList): string {
    return course && course.courseName ? course.courseName : '';
  }

  updateCourseFiltering() {
    this.filteredOptions = of(this.replacementCourse)
      .pipe(
        map(course => this.filterMaterial(course)),
      );
  }

  filterMaterial(values: any[]) {
    const searchingString = typeof this.selectedCourse === "string";

    if (searchingString) {
      const searchValue = this.selectedCourse?.toString().toLowerCase();
      return values.filter(course => course.courseName.toLowerCase().startsWith(searchValue));
    }

    return values.filter(course => course.courseName.toLowerCase().startsWith(this.selectedCourse));
  }

  fetchReplacementCourses() {
    this._courseservice.getReplacementCourse().subscribe({
      next: (resp) => {
        this.replacementCourse=resp;
      },
      error: (error) => {},
      complete: () => {
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const name = typeof value === 'string' ? value : value?.courseName;
            return name ? this._filter(name as string) : this.replacementCourse.slice();
          }),
        );
      }
    });
  }

  isOptionDisabledForCoursePrograms(optionId: number): boolean {
    return this.disabledPrograms.includes(optionId);
  }

  removeCourseThumbnailImage()
  {
    this.course.courseThumbnailFileId = 0;
    this.course.courseThumbnailName = '';
    this.isUploadComplete = false;
    this.uploadProgress = 0;
    this.selectedFileName = 'Drag and drop your file here or click to upload ';
  }

  downloadFile(){
    this.fileservice.downloadFile(this.course.courseThumbnailFileId).subscribe({
      next:(response) => {
        window.open(response.url, '_blank');
      }
    })
  }
}
